import { useState, useEffect, useContext } from "react";
import { StreamingContext } from "context/StreamingContext";
import { SignalContext } from "context/SignalContext";
import clsx from "clsx";
import { SvgLogo, SvgSnapshotRefresh, SvgSnapshotPtz } from "ui/svgs";
import type { SnapshotDataTypes } from "pages/service";
import { Popover } from "antd";
import { DbPicDataType } from "lib/types";
import { DB_STORE } from "lib/constants";
export default function CameraItem({
  objCamera,
  snapshot,
  autoPlayCameraId,
  canManualRetrySnap,
  onManualRetrySnap,
  onClickCamera,
  unSelectable,
  unSelectedPopText,
}: {
  objCamera: any;
  snapshot: SnapshotDataTypes;
  autoPlayCameraId: string;
  siteName: string;
  canManualRetrySnap: boolean;
  onManualRetrySnap: () => void;
  onClickCamera?: (objCamera) => void;
  unSelectable?: boolean;
  unSelectedPopText?: string;
}) {
  const urlParams = new URLSearchParams(window.location.search);
  const [online, setOnline] = useState(objCamera.status);
  const [disabled, setDisabled] = useState(false);
  const { wsMsgData, getDb } = useContext(SignalContext);
  const { streamingCameras } = useContext(StreamingContext);
  const [blobSrc, setBlobSrc] = useState<string>();
  useEffect(() => {
    if (!urlParams.get("camera")) return;
    const cameraIdList = urlParams.get("camera").split(",");
    if (
      cameraIdList.includes(objCamera.id + "") &&
      !(unSelectable || disabled)
    ) {
      onClickCamera?.(objCamera);
    }
  }, [objCamera]);
  useEffect(() => {
    if (
      !wsMsgData ||
      !wsMsgData.result ||
      wsMsgData.result.act !== "device.camera_status"
    ) {
      return;
    }
    if (
      wsMsgData.result.error ||
      !wsMsgData?.result?.data ||
      !wsMsgData.result.data.cameraStatus
    ) {
      return;
    }
    //sidebar camera status change
    wsMsgData?.result?.data.cameraStatus.id == objCamera.id &&
      setOnline(wsMsgData.result.data.cameraStatus.status);
  }, [wsMsgData]);

  useEffect(() => {
    //Disable if added
    setDisabled(streamingCameras.some((el) => el.cameraId === objCamera.id));
  }, [streamingCameras]);

  useEffect(() => {
    // auto play when retrurn from playback
    if (autoPlayCameraId == objCamera.id) {
      handleClickCamera();
    }

    if (snapshot?.blob) {
      setBlobSrc(URL.createObjectURL(snapshot?.blob));
    }
  }, [snapshot]);

  async function handleClickCamera() {
    onClickCamera?.(objCamera);
  }

  useEffect(() => {
    getDb().then((db) => {
      db.read(DB_STORE.SNAPSHOT, +objCamera?.id).then((data: DbPicDataType) => {
        data?.imageBlob && setBlobSrc(URL.createObjectURL(data?.imageBlob));
      });
    });
  }, []);

  return (
    <>
      <Popover content={unSelectable ? unSelectedPopText : null}>
        <button
          onClick={handleClickCamera}
          aria-disabled={unSelectable || disabled}
          disabled={unSelectable || disabled}
          className="disabled:opacity-40 disabled:cursor-not-allowed"
        >
          <div className="relative rounded-lg bg-gray-100">
            {/* <img src="/cameras/thumbnail-camera-placeholder.jpg" alt="Camera Placeholder" className="w-full h-24 object-cover rounded-lg" /> */}
            <div className="w-full aspect-video object-cover rounded-lg overflow-hidden">
              {blobSrc ? (
                <img
                  src={blobSrc}
                  alt="Camera Placeholder"
                  className="aspect-video"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  {canManualRetrySnap ? (
                    <div className="absolute top-0 right-0 w-full h-full flex justify-center items-center">
                      <button
                        onClick={(e) => {
                          onManualRetrySnap();
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <SvgSnapshotRefresh
                          width="22"
                          className="fill-neutral-500"
                        />
                      </button>
                    </div>
                  ) : (
                    <SvgLogo width="28" className="fill-zinc-400 mb-3" />
                  )}
                </div>
              )}
            </div>
            {/* // <img src={snapshot ? URL.createObjectURL(snapshot.blob) : '/cameras/thumbnail-camera-placeholder.jpg'} alt="Camera Placeholder" className="w-full aspect-video object-cover rounded-lg" /> */}
            <p className="absolute bottom-1 left-1 rounded-lg px-2 py-1 text-xs text-center text-white bg-neutral-800 bg-opacity-75 text-nowrap max-w-[80%] overflow-hidden break-words text-ellipsis break-all">
              <span
                className={clsx(
                  "inline-block w-2 h-2 rounded-full mr-1",
                  online == "online" ? "bg-emerald-400" : "bg-red-500",
                )}
              ></span>
              {objCamera.name}
            </p>
            {objCamera?.capabilities?.ptz && (
              <div className="absolute bottom-1 right-1 rounded-lg p-1 text-xs text-center bg-neutral-800 bg-opacity-75">
                <SvgSnapshotPtz className="fill-white" width="15" />
              </div>
            )}
          </div>
        </button>
      </Popover>
    </>
  );
}
